import homepage from './homepage'

const studentUnion = {
  path: 'studentUnion',
  component: resolve => require(['../../../components/pages/studentUnion'], resolve),
  redirect: 'studentUnion/homepage',
  children: [homepage]
}

export default studentUnion
